<template>
  <div class="container">
    <div class="contribution-page trans">
      <contribution-header
        :headerConfig="headerConfig"
        @handleClickIocn="handleClickIocn"
      />

      <div class="main">
        <h2 class="tit">论文编号</h2>
        <div class="contribution-form">
          <contribution-form
            :form="form"
            :list="list"
            :btns="btns"
            :rules="rules"
            labelPosition="top"
          />
        </div>
      </div>
    </div>
    <el-dialog
        title="提示"
        :visible.sync="confirmDialogVisible"
        width="80%"
        center>
        <span>确认提交？提交后将不能修改，请认真核对信息！</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="confirmDialogVisible = false">取 消</el-button>
          <el-button style="color: white;background-color: #fe0000;" @click="submit">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import contributionHeader from '@/components/header'
import contributionForm from '@/components/form'
import papersUpload from '@/components/upload'
import { Contributions } from '@/store/entity/contributions'
import merge from 'lodash/merge'

import CurrentConferMixin from '@/mixin/CurrentConference'
import CurrentUserMixin from '@/mixin/CurrentUser'
export default {
  name: 'contributions',
  components: {
    contributionHeader,
    contributionForm
  },
  mixins: [CurrentConferMixin, CurrentUserMixin],
  data() {
    return {
      confirmDialogVisible:false,
      headerConfig: {
        headerIcon: 'city ct-xiangyou',
        headerTitle: '我要投稿'
      },
      form: {
        // papername: "",
        // firstauthor: "",
        // firstphone: "",
        // cname: "",
        // cphone: "",
        // cemail: "",
        // file: "",
        title: '', //论文题目
        authorname: '', //第一作者姓名
        authorphone: '', //第一作者电话
        authorcompany: '', //第一作者单位
        corauthorname: '', //通讯作者姓名
        corauthorphone: '', //通讯作者电话
        corauthoremail: '',
        file_metadata: null
      },
      localItem: new Contributions(),

      rules: {
        title: [
          {
            required: true,
            message: '请输入论文题目',
            trigger: 'blur'
          }
        ],
        authorname: [
          {
            required: true,
            message: '请输入第一作者姓名',
            trigger: 'blur'
          }
        ],
        authorphone: [
          { required: true, message: '请输入第一作者电话' },
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: '请输入第一作者电话号码'
          }
        ],
        authorcompany: [
          {
            required: true,
            message: '请输入第一作者单位',
            trigger: 'blur'
          }
        ],
        corauthorname: [
          {
            required: true,
            message: '通讯作者姓名',
            trigger: 'blur'
          }
        ],
        corauthorphone: [
          { required: true, message: '请输入通讯作者电话' },
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: '请输入正确通讯作者电话号码'
          }
        ],
        corauthoremail: [
          { required: true, message: '请输入邮箱' },
          {
            pattern: /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/,
            message: '请输入正确通讯作者邮箱'
          }
        ],
        file_metadata: [
          {
            required: true,
            message: '请上传稿件',
            trigger: 'blur'
          }
        ]
      },

      isDisabled: false, //"提交投稿"按钮可用性。
      fileList: [
        {
          name: 'food.jpeg',
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        },
        {
          name: 'food2.jpeg',
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }
      ]
    }
  },
  async created() {
    if (this.$route.params.inform) {
      this.localItem = this.$route.params.inform
    } else if (this.$route.query.paper_id) {
      this.localItem = await Contributions.getById(this.$route.query.paper_id)
    } else {
      // pass
    }

    if (this.localItem) {
      // 有值的话写入form的初始值
      Object.keys(this.localItem).forEach((key) => {
        const value_of_info = this.localItem[key]
        if (key in this.form) {
          const value_of_form = this.form[key]
          if (!value_of_form && value_of_info) {
            this.form[key] = value_of_info
          }
        }
      })
    }
  },
  computed: {
    list() {
      let list = [
        {
          prop: 'title',
          render: 'ElInput',
          attrs: {
            placeholder: '论文题目'
          },
          position: {
            span: 24
          }
        },
        {
          prop: 'authorname',
          render: 'ElInput',
          attrs: {
            placeholder: '第一作者姓名'
          },
          position: {
            span: 24
          }
        },
        {
          prop: 'authorphone',
          render: 'ElInput',
          attrs: {
            placeholder: '第一作者电话'
          },
          position: {
            span: 24
          }
        },
        {
          prop: 'authorcompany',
          render: 'ElInput',
          attrs: {
            placeholder: '第一作者单位'
          },
          position: {
            span: 24
          }
        },
        {
          prop: 'corauthorname',
          render: 'ElInput',
          attrs: {
            placeholder: '通讯作者姓名'
          },
          position: {
            span: 24
          }
        },
        {
          prop: 'corauthorphone',
          render: 'ElInput',
          attrs: {
            placeholder: '通讯作者电话'
          },
          position: {
            span: 24
          }
        },
        {
          prop: 'corauthoremail',
          render: 'ElInput',
          attrs: {
            placeholder: '通讯作者邮箱'
          },
          position: {
            span: 24
          }
        }
      ]

      list.push({
        prop: 'file_metadata',
        render: papersUpload,
        attrs: {
          action: ``, //上传地址
          limit: 2,
          listType: 'text',
          fileList: 'fileList',
          uploadFileList:this.form.file_metadata,
          autoUpload: true
        },
        position: {
          span: 24
        }
      })
      return list
    },

    btns() {
      return [
        {
          label: this.isDisabled ? '投稿结束' : '提交投稿',
          attrs: {
            style: `
                        width: 100%; 
                        background: ${this.isDisabled ? '#999' : '#fe0000'};
                        color: #fff;
                        border: none
                        `,
            disabled: this.isDisabled,
            class: 'submit'
          },
          listeners: {
            click: this.handleFormSubmit
          }
        }
      ]
    }
  },

  methods: {
    handleClickIocn() {
      history.go(-1)
    },

    handleFormSubmit() {
      if (this.checkData()) { 
        if(this.localItem.id>0){
          this.confirmDialogVisible=true;
        }else{
          this.submit();
        }
      }
    },
    submit(){
      merge(this.localItem, this.form)
        this.localItem.conference_id = this.currentConference.id
        // handle: () => {
        this.localItem.createOrUpdate().then((item) => {
          this.localItem = item
          this.$router.push({
            name: 'paperSubmitType',
            query: { paper_id: this.localItem.id }
          })
          // this.$store.commit("handleChangeExamine", this.isNeedExamine)
        })
        //}
    },
    checkData() {
      if (!this.form.title || this.form.title.length > 60) {
        this.$message('论文题目不能为空且不能多于60个字')
        return false
      } else if (!this.form.authorname || this.form.authorname.length > 15) {
        this.$message('第一作者姓名不能为空且不能多于15个字')
        return false
      } else if (!this.checkPhone(this.form.authorphone)) {
        this.$message('请正确输入第一作者电话')
        return false
      } else if (!this.form.authorcompany || this.form.authorcompany.length > 100) {
        this.$message('第一作者单位不能为空且不能多于100个字')
        return false
      } 
      else if (!this.form.corauthorname || this.form.corauthorname.length > 15) {
        this.$message('通讯作者姓名不能为空且不能多于15个字')
        return false
      } else if (!this.checkPhone(this.form.corauthorphone)) {
        this.$message('请正确输入通讯作者电话')
        return false
      } else if (!this.checkEmail(this.form.corauthoremail)) {
        this.$message('请正确输入通讯作者邮箱')
        return false
      } else if (
        !this.form.file_metadata ||
        (this.form.file_metadata &&
          (this.form.file_metadata.length == 0 || this.form.file_metadata.length !== 2))
      ) {
        this.$message('必须上传‘摘要’和‘全文’2个附件')
        return false
      } else {
        return true
      }
    },
    checkEmail(email) {
      var reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/
      if (!reg.test(email)) {
        return false
      }
      return true
    },
    checkPhone(phone) {
      var reg = /^1(3|4|5|6|7|8|9)\d{9}$/
      if (!reg.test(phone)) {
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;

  .tit {
    padding-left: 5px;
    font-size: 16px;
    margin-top: 30px;
    border-left: 3px solid var(--main-color);
    font-weight: bold;
    color: var(--main-color);
  }

  .contribution-form {
    margin-top: 30px;

    ::v-deep .el-input__inner:focus {
      border-color: var(--main-color);
    }

    .el-form {
      .submit:focus,
      .submit:active,
      .submit:hover {
        color: #fff;
      }
    }
  }
}
</style>
